import { reduxKey } from '../reducers';
import { defaultStreamState } from '../constants';
export const getStreamIds = (state)=>state[reduxKey] && Object.keys(state[reduxKey]) || [];
export const getIsValidStream = (state, streamId)=>{
    var _state_reduxKey;
    return !!(state === null || state === void 0 ? void 0 : (_state_reduxKey = state[reduxKey]) === null || _state_reduxKey === void 0 ? void 0 : _state_reduxKey[streamId]);
};
export const getStream = (state, streamId)=>state[reduxKey] && state[reduxKey][streamId] || defaultStreamState;
export const getStreamType = (state, streamId)=>getStream(state, streamId).streamType;
export const getStreamIdsByGroupId = (state, groupId)=>{
    return Object.keys(state[reduxKey]).filter((streamId)=>getGroupId(state, streamId) === groupId);
};
export const findItemInStreams = (state, groupId, callback)=>{
    const streamIds = getStreamIdsByGroupId(state, groupId);
    let foundItem;
    streamIds.forEach((streamId)=>{
        if (!foundItem) {
            const items = getItems(state, streamId);
            foundItem = items.find(callback);
        }
    });
    return foundItem;
};
export const getGroupId = (state, streamId)=>getStream(state, streamId).groupId;
export const getStreamParams = (state, streamId)=>getStream(state, streamId).streamParams;
export const getStreamParamsSafe = (state, streamId)=>getStream(state, streamId).streamParams || {};
export const getStreamParam = (state, streamId, paramType)=>getStreamParamsSafe(state, streamId)[paramType];
export const getItemsPerFetch = (state, streamId)=>getStream(state, streamId).itemsPerFetch;
export const getItems = (state, streamId)=>getStream(state, streamId).items || [];
export const getTotal = (state, streamId)=>getStream(state, streamId).total || 0;
export const isInitialized = (state, streamId)=>state[reduxKey] !== undefined && state[reduxKey][streamId] !== undefined;
export const isFetching = (state, streamId)=>getStream(state, streamId).isFetching || false;
export const hasMore = (state, streamId)=>getStream(state, streamId).hasMore || false;
export const getHasLess = (state, streamId)=>getStream(state, streamId).hasLess || false;
export const getHasMoreInDirection = (state, streamId, direction = 'next')=>{
    switch(direction){
        case 'prev':
            return getHasLess(state, streamId);
        case 'all':
            return hasMore(state, streamId) || getHasLess(state, streamId);
        case 'next':
        default:
            return hasMore(state, streamId);
    }
};
export const getErrorMsg = (state, streamId)=>getStream(state, streamId).errorMsg;
export const getTotalItemsCount = (state)=>{
    let count = 0;
    const streamIds = getStreamIds(state);
    if (streamIds.length) {
        for (const streamId of streamIds){
            count += getItems(state, streamId).length;
        }
    }
    return count;
};
export const getFetchFailures = (state, streamId)=>getStream(state, streamId).fetchFailuresConsecutive || 0;
export const canStreamAutoFetch = (state, streamId)=>{
    return !isFetching(state, streamId) && !getErrorMsg(state, streamId) && hasMore(state, streamId) && getItems(state, streamId).length === 0;
};
